import Api from '@/api'


const fetchAll = () => {	
    return Api.get('api/entitycategories')
};

const postForm =  (payload,id) => {  
    
    if(typeof id != "undefined") { 
        
        return Api.put('api/entitycategories/' + id , payload)       
    } else {
        return Api.post('api/entitycategories' , payload)       
    }
    
};

const getById =  (payload) => {        
    return Api.get('api/entitycategories/' + payload)       
};

const deleteById =  (payload) => {        
    return Api.delete('api/entitycategories/'+payload)
    
};

export default {
  fetchAll,
  postForm,
  getById,
  deleteById
};